type Props = (value: string, keyword: string) => boolean;

const equalsText: Props = (value, keyword) => {
  const equals = value.toLowerCase().trim() === keyword.toLowerCase().trim();
  return equals;
};

export default equalsText;
